import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import chalk from "../utils/chalk";
import pako from "pako";
import user from "../objects/user/model";

const path = "/et/api";

export enum EEventType {
  // app_start = "user_action",
  user_action = "user_action",
  // page_view = "page_view",
  // custom_event = "custom_event",
}

export interface IUserAction {
  eventName: string;
  eventId: string;
  eventExtension?: Record<string, string>;
}

let isRefreshing = false;
let requests: ((token: string) => void)[] = [];
export const getToken = () => {
  const token = localStorage.getItem("traceLogToken");
  return token;
};

export const setToken = (token: string) => {
  localStorage.setItem("traceLogToken", token);
};

export const fetchToken = async () => {
  const {
    data: { token },
  } = await axios.get(`${path}/token`, {
    headers: {
      "x_app_id": "492e9a9e5bd135d6",
      "x_app_secret": "1816e30497496cf00cc52d497d679dfa",
    },
  });
  setToken(token);
  return token;
};

const gzipCompress = (data: string) => {
  // const binaryString = new TextEncoder().encode(data);
  const compressedData = pako.gzip(data);
  // const base64String = btoa(
  //   String.fromCharCode.apply(null, Array.from(compressedData)),
  // );
  return compressedData;
};

const gzipDecompress = (data: any) => {
  try {
    const rawStr = pako.ungzip(data, { to: "string" });
    // const rawStr = new TextDecoder().decode(byteStr);
    return JSON.parse(rawStr);
  } catch (error) {
    return {};
  }
};

const traceLogInstance = axios.create({
  baseURL: `${path}/events`,
  timeout: 60000,
  headers: {
    "Content-Type": "application/octet-stream",
    "Content-Encoding": "gzip",
    "platformType": PLATFORM_TYPE,
  },
});

traceLogInstance.interceptors.request.use(
  (request: any) => {
    const data = JSON.stringify(request.data);
    request.data = gzipCompress(data);
    request.headers.set("Authorization", `Bearer ${getToken()}`);
    return request;
  },
  error => {
    return Promise.reject(error);
  },
);

traceLogInstance.interceptors.response.use(
  (response: any) => {
    return response;
  },
  error => {
    const { status, config } = error.response;
    if ([401, 403].includes(status)) {
      if (!isRefreshing) {
        isRefreshing = true;
        return fetchToken()
          .then(token => {
            config.headers["Authorization"] = `Bearer ${token}`;
            config.data = gzipDecompress(config.data);
            if (requests.length) {
              requests.forEach(cb => cb(token));
              requests = [];
            }
            return traceLogInstance(config);
          })
          .catch(res => {
            console.error("refreshtoken error =>", res);
          })
          .finally(() => {
            isRefreshing = false;
          });
      } else {
        return new Promise(resolve => {
          requests.push((token: string) => {
            config.headers["Authorization"] = `Bearer ${token}`;
            config.data = gzipDecompress(config.data);
            resolve(traceLogInstance(config));
          });
        });
      }
    }
    return Promise.reject(error);
  },
);

const report = async (eventType: EEventType, eventDetails: IUserAction) => {
  const data = [
    {
      uid: uuidv4(),
      userId: user.userInfo?.id ?? "",
      timestamp: Date.now(),
      eventType,
      eventDetails,
    },
  ];
  await traceLogInstance.post("", data);
  chalk.traceLog(JSON.stringify(data));
};

export const reportUserAction = async (eventDetails: IUserAction) => {
  return await report(EEventType.user_action, eventDetails);
};
